// Initialize T4S Cart namespace
if (typeof window.T4S === "undefined") window.T4S = {};

window.T4S.Cart = (function () {
  // Error handling for template loading
  window.addEventListener("error", function (e) {
    if (e.filename && e.filename.includes("pink-vasant-dress")) {
      console.warn("Product template loading prevented:", e.filename);
      e.preventDefault();
      return true;
    }
  });

  // Private variables
  const selectors = {
    cartForms: 'form[action="/cart/add"]',
    cartCount: ".t4s-cart-count",
    miniCart: "#t4s-mini_cart",
    cartDrawerTrigger: '[data-drawer-options*="#t4s-mini_cart"]',
  };

  // Private methods
  const _setupEventListeners = function () {
    // Handle add to cart forms
    document.querySelectorAll(selectors.cartForms).forEach((form) => {
      form.addEventListener("submit", _handleAddToCart);
    });

    // Handle cart drawer triggers
    document
      .querySelectorAll(selectors.cartDrawerTrigger)
      .forEach((trigger) => {
        trigger.addEventListener("click", _handleCartTriggerClick);
      });

    // Handle product templates
    document.addEventListener("DOMContentLoaded", function () {
      const productTemplates = document.querySelectorAll(
        "[data-product-template]"
      );
      productTemplates.forEach((template) => {
        if (template.src && template.src.includes("pink-vasant-dress")) {
          template.type = "text/template";
        }
      });
    });
  };

  const _handleAddToCart = async function (event) {
    event.preventDefault();
    const form = event.target;
    const submitButton = form.querySelector('[type="submit"]');

    try {
      if (submitButton) submitButton.disabled = true;

      const response = await fetch("/cart/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: new FormData(form),
      });

      if (!response.ok) throw new Error("Add to cart failed");

      const cartResponse = await fetch("/cart.json");
      const cartData = await cartResponse.json();

      // Update cart count
      _updateCartCount(cartData.item_count);

      // Open cart drawer
      _openCartDrawer();
    } catch (error) {
      console.error("Cart error:", error);
      // Handle error - show error message to user
    } finally {
      if (submitButton) submitButton.disabled = false;
    }
  };

  const _handleCartTriggerClick = function (event) {
    event.preventDefault();
    _openCartDrawer();
  };

  const _updateCartCount = function (count) {
    document.querySelectorAll(selectors.cartCount).forEach((element) => {
      element.textContent = count;
      element.setAttribute("data-cart-count", count);
    });
  };

  const _openCartDrawer = function () {
    if (
      window.T4S.CartDrawer &&
      typeof window.T4S.CartDrawer.open === "function"
    ) {
      window.T4S.CartDrawer.open();
    } else {
      // Fallback if drawer not initialized
      window.location.href = "/cart";
    }
  };

  // Public methods
  return {
    init: function () {
      _setupEventListeners();

      // Initialize cart count on page load
      fetch("/cart.json")
        .then((response) => response.json())
        .then((data) => _updateCartCount(data.item_count))
        .catch((error) => console.error("Error fetching cart:", error));
    },

    refreshCart: async function () {
      try {
        const response = await fetch("/cart.json");
        const cart = await response.json();
        _updateCartCount(cart.item_count);
        return cart;
      } catch (error) {
        console.error("Error refreshing cart:", error);
        return null;
      }
    },
  };
})();

// Initialize cart on DOM content loaded
document.addEventListener("DOMContentLoaded", function () {
  window.T4S.Cart.init();
});
